import React from "react";
import "../../css/Common/CommonPopUp.css";

export default function CommonPopUpModal({
	isOpen,
	onClose,
	onConfirm,
	title,
	message,
	pageType = "info",
	confirmText = "OK",
	cancelText = "Cancel",
}) {
	if (!isOpen) return null;

	const modalConfig = {
		cart: {
			title: "A Fine Choice!",
			showCancel: false,
			confirmText: "Continue Shopping",
		},
		enquiry: {
			title: title || "Enquiry Sent",
			showCancel: false,
			confirmText: "OK",
		},
		delete: {
			title: "Remove Item?",
			showCancel: true,
			confirmText: "Remove",
		},
		successDelete: {
			title: "Item Removed",
			showCancel: false,
			confirmText: "OK",
		},
		error: {
			title: "Error",
			showCancel: false,
			confirmText: "Close",
		},
		logout: {
			title: "Are You Logging Out?",
			showCancel: true,
			confirmText: "Log out",
			cancelText: "Cancel",
		},
		info: {
			title: title || "Information",
			showCancel: false,
			confirmText: "OK",
		},
		login: {
			title: "Welcome",
			showCancel: false,
			showConfirm: false,
		},
	};

	const config = modalConfig[pageType] || modalConfig.info;

	return (
		<>
			<div className="modal fade show d-block" tabIndex="-1">
				<div className="modal-dialog modal-dialog-centered justify-content-center">
					<div className={`modal-content commomPopup-modal ${pageType}`}>
						<div
							className="commomPopup-banner"
							style={{
								backgroundImage: "url(/assets/images/Logo/Midamas_Logo_2_15.png)",
							}}
						/>

						<div className="commomPopup-body mt-3">
							<div className="commomPopup-title">
								{title || config.title}
							</div>

							<div className="commomPopup-text">
								{message}
							</div>

							{config.showConfirm !== false && (
								<div className="commomPopup-btn-row">
									{config.showCancel && (
										<button
											className="commomPopup-btn-cancel"
											onClick={onClose}
										>
											{config.cancelText || cancelText}
										</button>
									)}

									<button
										className="commomPopup-btn-confirm"
										onClick={onConfirm || onClose}
									>
										{config.confirmText || confirmText}
									</button>
								</div>
							)}
						</div>

					</div>
				</div>
			</div>

			<div className="modal-backdrop fade show" />
		</>
	);
}
